import twoSpirit from './logos/2Spirit-Consultants-MB logo-06-24.jpg';
import logoVenuiti from './logos/VHealthLogo.png';
import palliativeManitoba from './logos/Palliative_Manitoba_RGB.png';
import winnipgeFdn from './logos/Winnipge_Fdn_Colour.png';

import vacLogo from './logos/FundedByVAC-wordmark-en.png';
import cvhLogo from './logos/CGA-CVHVector-en.svg';
import vacLogoFr from './logos/FundedByVAC-wordmark-fr.png';
import cvhLogoFr from './logos/CGA-CVHVector-fr.svg';
import venuitiLogo from './logos/VHealthLogo.png';

import { ArrowPropsModel } from "components/HomeCarousel/components/Arrows";
import { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import '../FullFooter/footer.scss';
import { useTranslates } from "providers/translates";
import { isVac } from "utilities/is-vac";
import { Language } from 'providers/translates/enums';

const vacLogos = [vacLogo, cvhLogo, venuitiLogo];
const vacFrLogos = [vacLogoFr, cvhLogoFr, venuitiLogo];
const memorialLogos = [twoSpirit, palliativeManitoba, winnipgeFdn, logoVenuiti];

const CustomLeftArrow: React.FC<ArrowPropsModel> = ({ onClick, ...rest }) => {
  return (
    <div className="angle-left slick-arrow" onClick={onClick}>
      <i className="fa fa-chevron-left"></i>
    </div>
  );
};

const CustomRightArrow: React.FC<ArrowPropsModel> = ({ onClick, ...rest }) => {
  return (
    <div className="angle-right slick-arrow" onClick={onClick}>
      <i className="fa fa-chevron-right"></i>
    </div>
  );
};

const slidesToShow = (screenWidth: number) => {
  if (screenWidth <= 420) return 1;
  if (screenWidth <= 700) return 2;
  if (screenWidth <= 900) return 3;
  return isVac() ? 3 : 4;
};

type Props = {
  isHomePage?: boolean;
}

const Partners: React.FC<Props> = ({
  isHomePage
}) => {
  const { translates: t, selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    settings = {
      ...settings,
      slidesToShow: slidesToShow(width),
    };
  }, [width]);

  let settings = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,    
    slidesToShow: slidesToShow(document.documentElement.clientWidth),
    slidesToScroll: 1,
    nextArrow: <CustomRightArrow />,
    prevArrow: <CustomLeftArrow />,
  };

  const logos = useMemo(() => {
    if (!isVac()) {
      return memorialLogos;
    }
    return isFrench ? vacFrLogos : vacLogos;
  }, [selectedLang]);

  return (
    <div className="partners center">
      {isHomePage && (
        <div className='partners__mainTitle'>
          {t?.footer?.partnersLabel || 'Partners'}
        </div>
      )}
      <div style={{ position: 'relative', padding: '28px 0', margin: '0 15px' }}>
        <Slider {...settings}>
          {logos.map((footerImg, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
              <div className="carousel_item">
                <img
                  style={{
                    height: i === 0 ? '124px' : '65px',
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                  src={footerImg}
                  alt="logo"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      {/*{isVac() ? (  
        isHomePage && (
            <div
              style={{
                color: '#4fa6c6',
                fontStyle: 'italic',
                fontSize: '31px',
                fontWeight: 600,
                padding: '28px',
              }}
            >
              {t?.home?.supportersHeading || 'Supporters'}
            </div>
          )
            ) : null} */}
    </div>
  );
};

export { Partners };